import {
    fetchAPI,
    joinParams
} from '../alias/utils'
import API from '../config/api'


async function getWebStatusReady(params = {
    code
}){
    let {code} = params

    let _search = joinParams(params)

    let url = `${API.INDEXSTATUS.url}?${_search}`

    let _params = Object.assign({}, API.INDEXSTATUS, {
        url
    })

    let res = await fetchAPI(_params)

    return res
}

async function getCountryCode() {

    let url = `${API.GetCountryCode.url}`

    let _params = Object.assign({}, API.GetCountryCode, {
        url
    })

    let res = await fetchAPI(_params)

    return res
}

async function getCustomerInfo(params = {
    ssoTokenWithWeChatUserInfoData
}, token) {

    let url = `${API.GetCustomerInfo.url}`

    let _params = Object.assign({}, API.GetCustomerInfo, {url}, {body : params})

    let res = await fetchAPI(_params, token)

    return res
}

async function sendEnrollmentFrom(params = {
    enrollmentFormData
}, token) {

    let url = `${API.sendEnrollmentForm.url}`

    let _params = Object.assign({}, API.sendEnrollmentForm, {url}, {body : params})

    let res = await fetchAPI(_params, token)

    return res
}

async function sendLoginFrom(params = {
    loginFormData
}, token) {

    let url = `${API.sendLoginForm.url}`

    let _params = Object.assign({}, API.sendLoginForm, {url}, {body : params})

    let res = await fetchAPI(_params, token)

    return res
}

async function getPinYinTranslation(params = {
    text
}) {

    let _search = joinParams(params)

    let url = `${API.GetPinYinTranslation.url}?${_search}`

    let _params = Object.assign({}, API.GetPinYinTranslation, {
        url
    })

    let res = await fetchAPI(_params)

    return res
}

async function getWXconfig(params = {
    currentUrl
}){

    let _search = joinParams(params)

    let url = `${API.GetWXconfig.url}?${_search}`

    let _params = Object.assign({}, API.GetWXconfig, {
        url
    })

    let res = await fetchAPI(_params)

    return res
}

async function createCardSig() {

    let url = `${API.CreateCardSig.url}`

    let _params = Object.assign({}, API.CreateCardSig, {
        url
    })

    let res = await fetchAPI(_params)

    return res
}

async function getCsrfToken() {

    let url = `${API.GetCsrfToken.url}`

    let _params = Object.assign({}, API.GetCsrfToken, {
        url
    })

    let res = await fetchAPI(_params)

    return res
}


export {
    getWebStatusReady,
    getCountryCode,
    getCustomerInfo,
    sendEnrollmentFrom,
    sendLoginFrom,
    getPinYinTranslation,
    getWXconfig,
    createCardSig,
    getCsrfToken
}


// WEBPACK FOOTER //
// ./src/api/index.js